import React, { useMemo } from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Animated skeleton loader for note sections
 * Shows 2-3 paragraph-like loading placeholders with subtle randomization
 */
export const SectionLoadingSkeleton: React.FC = () => {
  // Generate slightly randomized paragraph count and widths for organic feel
  const paragraphs = useMemo(() => {
    const count = Math.random() > 0.3 ? 3 : 2; // 70% chance of 3 paragraphs, 30% chance of 2

    return Array.from({ length: count }, (_, i) => {
      // Create varying widths with slight randomization
      const baseWidths = [95, 88, 75]; // Base widths for natural paragraph look
      const baseWidth = baseWidths[i] || 80;
      const randomVariation = Math.floor(Math.random() * 8) - 4; // -4 to +4% variation
      const width = Math.max(70, Math.min(100, baseWidth + randomVariation));

      return { width: `${width}%` };
    });
  }, []); // Generate once per component mount

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      {paragraphs.map((paragraph, index) => (
        <Skeleton
          key={index}
          variant="text"
          width={paragraph.width}
          height={20}
          animation="wave"
          sx={{
            bgcolor: 'rgba(0, 0, 0, 0.06)',
            borderRadius: 0.5,
          }}
        />
      ))}
    </Box>
  );
};
